import React from "react";

const InstagramFloatingIcon = () => {
  return (
    <div class="avx-feedback-float-icon">
      <div
        class="fb-float-icon"
        onClick={() =>
          window.open(
            "https://www.instagram.com/wortheweight?igsh=ZmxxaW1kYzRhaW16",
            "_blank"
          )
        }
      >
        DM us on Instagram{" "}
      </div>
    </div>
  );
};

export default InstagramFloatingIcon;
